import React from 'react';
import GallectionsGrid from '../GallectionGrid';
import SearchInput from '../../_partials/SearchInput';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import FolderCard from '../../_partials/FolderCard';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useGallections } from '../../_hocs/withGallections';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

export interface Props {
  /** don't show the search input */
  disableSearch?: boolean;
}

const GallectionExplorer: React.FC<Props> = ({ disableSearch }) => {
  const {
    gallections,
    hasMoreGallections,
    isFetchingGallections,
    isGallectionStreamInitialized,
    fetchMoreGallections,
  } = useGallections();

  const fetchMoreGallectionsIfNeeded = () => {
    if (!hasMoreGallections || isFetchingGallections) {
      return;
    }
    fetchMoreGallections();
  };

  const renderGallection = ({
    index,
    width,
  }: {
    index: number;
    width: number;
  }) => {
    const gallection = gallections[index];
    return <FolderCard width={width} folder={gallection} />;
  };

  const renderContent = () => {
    return (
      <>
        {isGallectionStreamInitialized && (
          <GallectionsGrid
            cookieType={MeasuredCookieType.GALLECTION_EXPLORER}
            gallections={gallections}
            gallectionRenderer={renderGallection}
          />
        )}
        {hasMoreGallections && (
          <LoadingIndicator
            view="daSymbol"
            coverMode={!gallections.length && hasMoreGallections}
          />
        )}
      </>
    );
  };

  return (
    <PopupInnerLayout
      headerExtrasRightZone={disableSearch ? undefined : <SearchInput />}
      scrollableContent={renderContent()}
      onScrolledToBottom={fetchMoreGallectionsIfNeeded}
      onNotScrollable={fetchMoreGallectionsIfNeeded}
    />
  );
};

export default GallectionExplorer;
